import {
  getLessonsById,
  getModuleById,
  getModuleProgress,
  getLessonProgress,
  getLessonProgressById,
  getStudentById,
} from "@/api/api";
import store from "../store";
import {
  LessonsStepDefinition,
  PracticeStepDefinition,
  stepTypes,
} from "@/components/Lessons/Lesson/stepsDefinition";

export const ARCHES_OPEN_STUDENT_TASK_KEY = "arches_open_student_task";

export async function consumeOpenStudentTask(router, payload) {
  const { lessonUuid, studentUuid, studentEmail, stepType, stepNumber } = payload;

  const profile = store.getters.profile;
  if (profile?.role === "TEACHER" && studentUuid) {
    const studentResp = await getStudentById(studentUuid);
    store.commit("updateStudent", studentResp.data);
  }

  const { data: lessonResponse } = await getLessonsById(lessonUuid);
  const { data: moduleResponse } = await getModuleById(lessonResponse.module);

  const progressResponse = await getModuleProgress({
    module__uuid: moduleResponse.uuid,
    student__email: studentEmail,
  });
  const moduleProgress = progressResponse.data.results[0];
  if (!moduleProgress) {
    await router.push({ name: "modules" });
    return;
  }

  const lessonProgressResp = await getLessonProgress({
    student__email: studentEmail,
    lesson__uuid: lessonResponse.uuid,
  });
  const firstLp = lessonProgressResp.data.results[0];
  if (!firstLp) {
    await router.push({ name: "modules" });
    return;
  }
  const { data: lessonProgressByUuid } = await getLessonProgressById(firstLp.uuid);

  store.commit("modules/selectedModule", moduleResponse);
  store.commit("progress/module", moduleProgress);
  store.commit("modules/currentLesson", lessonResponse);
  store.commit("progress/lesson", lessonProgressByUuid);

  await store.dispatch("lesson/teacher_lesson", lessonResponse.teacher_lesson);
  await store.dispatch("lesson/practice", lessonResponse.practice);
  await store.dispatch("lesson/grammar", lessonResponse.grammar);

  const stepDefinition = stepTypes.find((s) => s.value === stepType);
  if (!stepDefinition) {
    await router.push({ name: "lesson-view" });
    return;
  }

  let index = 1;
  let route = { name: "lesson-view" };

  switch (stepDefinition.key) {
    case "TEACH_INTRO":
      await router.push({ name: "introduction" });
      return;
    case "GRAMMAR_EXERCISE": {
      const ex = Number(stepNumber);
      const idx = Number.isFinite(ex) && ex >= 1 ? ex : 1;
      await router.push({
        name: "exercise",
        params: { index: String(idx) },
      });
      return;
    }
    case "TEACH_GRAMMAR_INTRO": {
      const gi = LessonsStepDefinition.indexOf("Grammar");
      store.commit("lesson/step", gi >= 0 ? gi : 0);
      await router.push({
        name: "guided-lesson",
        query: { gn: Math.max(0, Number(stepNumber) || 0) },
      });
      return;
    }
    default:
      switch (stepDefinition.section) {
        case "TEACHER_LESSON":
          index = LessonsStepDefinition.indexOf(stepDefinition.key);
          if (index < 0) {
            index = 0;
          }
          route = { name: "guided-lesson" };
          if (stepDefinition.key === "Speaking") {
            route.query = { sn: Math.max(0, Number(stepNumber) || 0) };
          } else if (stepDefinition.key === "Grammar") {
            if (stepNumber >= 0) {
              route.query = { gn: stepNumber };
            }
          } else if (stepDefinition.key === "Homework") {
            route.query = { hn: Math.max(0, Number(stepNumber) || 0) };
          }
          break;
        case "PRACTICE":
          index = PracticeStepDefinition.indexOf(stepDefinition.key);
          if (index < 0) {
            index = 0;
          }
          route = { name: "practice" };
          if (stepDefinition.key === "Speaking") {
            route.query = { sn: Math.max(0, Number(stepNumber) || 0) };
          } else if (stepDefinition.key === "Homework") {
            route.query = { hn: Math.max(0, Number(stepNumber) || 0) };
          }
          break;
        default:
          break;
      }
      if (route.name === "lesson-view") {
        await router.push({ name: "introduction" });
        return;
      }
      store.commit("lesson/step", index);
      await router.push(route);
  }
}
